import React from 'react';

function PmsUpdateHistorySkeleton({ count = 5 }) {
    return (
        <div className="pms-update-history-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <div className="pms-update-history-skeleton__item" key={`pms-history-skeleton-${index}`}>
                    <div className="pms-update-history-skeleton__line pms-update-history-skeleton__line--medium mb-2"></div>
                    <div className="pms-update-history-skeleton__line pms-update-history-skeleton__line--short mb-3"></div>
                    <div className="pms-update-history-skeleton__line pms-update-history-skeleton__line--long"></div>
                </div>
            ))}
        </div>
    );
}

export default PmsUpdateHistorySkeleton;
